import { createIconComponent } from './helpers';
import { faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

export const XCircleIcon = createIconComponent(faTimesCircle);
